import { Dispositif } from '../shared/Dispositif'
import { Entites } from '../shared/Entite'


export const TypePermissionEntite = Entites
export type TypePermissionEntite = (typeof TypePermissionEntite)[number]
export const TypePermissionDispositif = Dispositif
export type TypePermissionDispositif = (typeof TypePermissionDispositif)[number]

export const TypePermission = [...TypePermissionEntite, ...TypePermissionDispositif] as const
export type TypePermission = TypePermissionEntite | TypePermissionDispositif

export type TypePermissionLike = Entites | Dispositif

export const TypePermissionEntiteMap: Record<Entites, TypePermissionEntite> = {
  RIB: 'RIB',
  Administration: 'Administration',
  Virement: 'Virement',
  Facture: 'Facture',
  DR: 'DR',
} as const

export type TypePermissionEntiteMap = (typeof TypePermissionEntiteMap)[Entites]

export const TypePermissionDispositifMap: Record<Dispositif, TypePermissionDispositif> = {
  CPRO: 'CPRO',
  CAPP: 'CAPP',
  PROA: 'PROA',
  AF: 'AF',
  FPE: 'FPE',
} as const

export type TypePermissionDispositifMap = (typeof TypePermissionDispositifMap)[Dispositif]

export const TypePermissionMap: Record<TypePermissionLike, TypePermission> = {
  ...TypePermissionEntiteMap,
  ...TypePermissionDispositifMap
} as const
export type TypePermissionMap = (typeof TypePermissionMap)[TypePermissionLike]

export const TypePermissionLibelle: Record<TypePermission, string> = {
  CPRO: 'Contrat pro',
  CAPP: 'Contrat d\'apprentissage',
  PROA: 'Contrat PROA',
  FPE: 'DRF, CDPI, CIPI et AF FPE',
  AF: 'Action formation',
  DR: 'DR et PROFORMA',
  Facture: 'Facture',
  RIB: 'RIB',
  Administration: 'Administration',
  Virement: 'Virement',
} as const
